import React, { createElement } from 'react';
import { ForwardRefProps, WithInnerRef } from '../../utils/forwardRefs';
import { HeadingProps } from './types';

interface Props extends HeadingProps {
  className?: string;
}

const BaseHeadingComponent: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<WithInnerRef<Props, HTMLHeadingElement>>>
> = ({ children, innerRef, level = 1, tabIndex, className }) => {
  return typeof level === 'number' && !isNaN(level) && level <= 6 ? (
    createElement(`h${level}`, { className, tabIndex, ref: innerRef }, children)
  ) : (
    <p className={className} tabIndex={tabIndex} ref={innerRef}>
      {children}
    </p>
  );
};

/**
 * @deprecated Use h1-h6 with tailwind classes instead.
 */
export const BaseHeading = React.forwardRef<HTMLHeadingElement, ForwardRefProps<HeadingProps>>(
  (props, ref) => {
    return <BaseHeadingComponent innerRef={ref} {...props} />;
  }
);
